function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGermlineIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 6.35 6.35"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "germline_icon_svg__b",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.854,
  cy: 292.498,
  r: 0.793,
  style: {
    opacity: 1,
    fill: "none",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0,
    strokeLinejoin: "round",
    strokeMiterlimit: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    paintOrder: "markers fill stroke"
  }
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "germline_icon_svg__d",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.854,
  cy: 292.498,
  r: 0.793,
  style: {
    opacity: 1,
    fill: "none",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0,
    strokeLinejoin: "round",
    strokeMiterlimit: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    paintOrder: "markers fill stroke"
  }
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "germline_icon_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.579,
  height: 1.579,
  x: 3.708,
  y: 291.705,
  ry: 0.186,
  style: {
    fill: "#fff",
    strokeWidth: 0.27012414
  }
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "germline_icon_svg__c",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2.638,
  height: 0.935,
  x: 1.974,
  y: 293.69,
  rx: 0.21,
  ry: 0.209,
  style: {
    fill: "#fff",
    strokeWidth: 0.2698113
  }
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -290.65)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.579,
  height: 1.579,
  x: 3.708,
  y: 291.705,
  clipPath: "url(#germline_icon_svg__a)",
  ry: 0,
  style: {
    fill: "none",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.52916664,
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers"
  },
  transform: "matrix(1.4262 0 0 1.4262 -1.352 -125.36)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.854,
  cy: 292.498,
  r: 0.793,
  clipPath: "url(#germline_icon_svg__b)",
  style: {
    opacity: 1,
    fill: "none",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.92757701,
    strokeLinejoin: "round",
    strokeMiterlimit: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    paintOrder: "markers fill stroke"
  },
  transform: "matrix(1.4262 0 0 1.4262 -1.352 -125.36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.466 294.616v-.777H2.124v.91",
  clipPath: "url(#germline_icon_svg__c)",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.37103081,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    strokeDasharray: "none"
  },
  transform: "matrix(1.4262 0 0 1.4262 -1.352 -125.36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.174 293.685v-1.872h-.963 2.105",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.52916666,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    strokeDasharray: "none"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.854,
  cy: 292.498,
  r: 0.793,
  clipPath: "url(#germline_icon_svg__d)",
  style: {
    opacity: 1,
    fill: "none",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.92757701,
    strokeLinejoin: "round",
    strokeMiterlimit: 0,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    paintOrder: "markers fill stroke"
  },
  transform: "matrix(1.4262 0 0 1.4262 2.354 -121.303)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.579,
  height: 1.579,
  x: 3.708,
  y: 291.705,
  clipPath: "url(#germline_icon_svg__a)",
  ry: 0,
  style: {
    fill: "none",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.52916664,
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers"
  },
  transform: "matrix(1.4262 0 0 1.4262 -4.755 -121.314)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.104 294.535h.121v.245h-.121z",
  style: {
    fill: "#000",
    strokeWidth: 0.37735054
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.466 294.493h.099v.231h-.099z",
  style: {
    fill: "#000",
    strokeWidth: 0.38350672
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m.726 296.714 1.875-1.81M.747 295.794l.94-.87M1.667 296.714l.934-.94",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: ".37735054px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.579,
  height: 1.579,
  x: 3.708,
  y: 291.705,
  clipPath: "url(#germline_icon_svg__a)",
  ry: 0,
  style: {
    fill: "none",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.52916664,
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers"
  },
  transform: "matrix(1.4262 0 0 1.4262 -1.352 -125.36)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.13 292.668 1.874-1.81M4.15 291.748l.94-.87M5.07 292.668l.934-.94",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: ".37735054px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M.744 294.916h1.753v1.736H.744zM4.192 290.89h1.712v1.703H4.192z",
  style: {
    fill: "#000",
    fillOpacity: 1,
    strokeWidth: 0.26458332,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none"
  }
})));
export default SvgGermlineIcon;